import React, { useState } from 'react';
import { IconWorld } from '@tabler/icons-react';
import RouteOverviewGlobeModal from './RouteOverviewGlobeModal';
import './MobileRouteGlobeButton.css';

// Mobile-only entry point to the globe overview modal. The desktop entry
// point is the bottom-left minimap, which is hidden on phones — this button
// gives phone users the same "where on Earth is this route" view.
//
// Props mirror RouteOverviewGlobeModal so the same modal can be reused.
export default function MobileRouteGlobeButton({
  coordinates,
  theme,
  switchCheckpointIndex,
  routeTitle,
  routeDistanceKm,
  startLabel,
  endLabel,
}) {
  const [isOpen, setIsOpen] = useState(false);

  if (!coordinates || coordinates.length < 2) return null;

  return (
    <>
      <button
        type="button"
        className="mobile-route-globe-button"
        onClick={() => setIsOpen(true)}
        aria-label="View route on globe"
      >
        <IconWorld size={22} />
      </button>
      {isOpen && (
        <RouteOverviewGlobeModal
          coordinates={coordinates}
          theme={theme}
          switchCheckpointIndex={switchCheckpointIndex}
          routeTitle={routeTitle}
          routeDistanceKm={routeDistanceKm}
          startLabel={startLabel}
          endLabel={endLabel}
          onClose={() => setIsOpen(false)}
        />
      )}
    </>
  );
}
